import { useEffect } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { CheckCircle, ArrowRight } from "lucide-react";
import { useSubscription } from "@/hooks/useSubscription";

export default function SubscriptionSuccess() {
  const { checkSubscription } = useSubscription();

  useEffect(() => {
    // Refresh subscription status after successful payment
    const timer = setTimeout(() => {
      checkSubscription();
    }, 2000);
    return () => clearTimeout(timer);
  }, [checkSubscription]);

  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-6">
      <div className="max-w-md w-full text-center">
        <div className="inline-flex p-4 rounded-full bg-primary/10 mb-6">
          <CheckCircle className="h-16 w-16 text-primary" />
        </div>
        
        <h1 className="text-3xl font-bold mb-4">Welcome to Aiveliq360!</h1>
        
        <p className="text-muted-foreground mb-8">
          Your subscription has been activated. You now have full access to all
          the AI-powered sales features.
        </p>

        <div className="space-y-4">
          <Link to="/app">
            <Button className="w-full gap-2 ai-glow">
              Go to Dashboard
              <ArrowRight className="h-4 w-4" />
            </Button>
          </Link>
          
          <Link to="/">
            <Button variant="outline" className="w-full">
              Back to Home
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
}
